import React from 'react';
import OrderDetailFields from '../../components/OrderDetailFields';

const OrderComponentPrint = (props) => {

    const { item = null, order = null, content = null, intl } = props;

    const renderDetail = (content) => {
        var detail = content.additionalAttributesJson != '' && JSON.parse(content.additionalAttributesJson);
        return <OrderDetailFields detail={detail} intl={intl} className="" />
    }

    return (
        <>
            <title>&nbsp;</title>
            <style>
                {`
             @media print {
                @page {
                    size: 101mm 59mm;
                    margin: 0;
                }
             }
             html, #smprint div, #smprint span, #smprint applet, #smprint object, #smprint iframe, #smprint h1, #smprint h2, #smprint h3, #smprint h4, #smprint h5, #smprint h6, #smprint p, #smprint blockquote, #smprint pre, #smprint a, #smprint abbr, #smprint acronym, #smprint address, #smprint big, #smprint cite, #smprint code, #smprint del, #smprint dfn, #smprint em, #smprint img, #smprint ins, #smprint kbd, #smprint q, #smprint s, #smprint samp, #smprint small, #smprint strike, #smprint sub, #smprint sup, #smprint tt, #smprint var, #smprint b, #smprint u, #smprint i, #smprint center, #smprint dl, #smprint dt, #smprint dd, #smprint ol, #smprint ul, #smprint li, #smprint fieldset, #smprint form, #smprint label, #smprint legend, #smprint table, #smprint caption, #smprint tbody, #smprint tfoot, #smprint thead, #smprint tr, #smprint th, #smprint td, #smprint article, #smprint aside, #smprint canvas, #smprint details, #smprint embed, #smprint figure, #smprint figcaption, #smprint footer, #smprint header, #smprint hgroup, #smprint menu, #smprint nav, #smprint output, #smprint ruby, #smprint section, #smprint summary, #smprint time, #smprint mark, #smprint audio, #smprint video {
              margin: 0;
              padding: 0;
              border: 0;
              font-size: 100%;
              font: inherit;
              vertical-align: baseline;
            }
  
            /* HTML5 display-role reset for older browsers */
            article, aside, details, figcaption, figure,
            footer, header, hgroup, menu, nav, section {
                display: block;
            }
  
            body {
                margin: 0;
                padding: 2mm;
                width: 101mm;
                height: 59mm;
                box-sizing: border-box;
            }
  
            #smprint blockquote, #smprint q {
                quotes: none;
            }
  
            #smprint blockquote:before, #smprint blockquote:after,
            #smprint q:before, #smprint q:after {
                content: '';
                content: none;
            }
  
            b {
              font-weight: bolder !important;
            }

            #smprint table {
                font-family: arial, sans-serif;
                line-height: 1.2;
                font-size: 11px;
                width: 100%;
            }
  
            #smprint.smprint-new table table { font-family: unset; width: 100%; } 
            
            .print-table td {
                padding: 1px;
            }
  
            `}
            </style>
            <div id="smprint" className={'smprint-new'} >
                <div>
                    <table className="print-table">
                        <tr>
                            <td colSpan={3} style={{ textAlign: "center", fontSize: "14px", paddingBottom: "3px" }}><b>{intl.formatMessage({ id: 'PRINT.ORDER_NUMBER' })} : {order.id}</b></td>
                        </tr>
                        <tr>
                            <td style={{ verticalAlign: "middle", textAlign: "center", width: "25%" }}>
                                {
                                    content.imageLink ? <img src={content.imageLink} style={{ maxWidth: "100%", maxHeight: "40mm" }}></img> : null
                                }
                            </td>
                            <td style={{ verticalAlign: "middle", textAlign: "left", paddingLeft: "5px" }}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td width="30%"><b>{intl.formatMessage({ id: 'PRINT.CLIENT' })} :</b>  </td>
                                            <td width="70%">{order.user && order.user.contact && order.user.contact.company} </td>
                                        </tr>
                                        <tr>
                                            <td width="30%"> <b>{intl.formatMessage({ id: 'PRINT.REF' })} :</b> </td>
                                            <td width="70%">{order && order.reference} </td>
                                        </tr>
                                        <tr>
                                            <td width="30%"><b>{intl.formatMessage({ id: 'PRINT.PRODUCT' })} :</b> </td>
                                            <td width="70%">{content.productId} - {content.productName}</td>
                                        </tr>
                                        <tr>
                                            <td width="30%"><b>{intl.formatMessage({ id: 'PRINT.VARIANT' })} :</b> </td>
                                            <td width="70%">{content.variantId} - {content.variantName}</td>
                                        </tr>
                                        <tr>
                                            <td width="30%"><b>{intl.formatMessage({ id: 'PRINT.QUANTITY' })} :</b> </td>
                                            <td width="70%">{content.quantity}</td>
                                        </tr>
                                        <tr>
                                            <td width="30%"><b>{intl.formatMessage({ id: 'PRINT.DETAILS' })} :</b> </td>
                                            <td width="70%">
                                                {renderDetail(content)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                            <td style={{ verticalAlign: "middle", textAlign: "center", width: "15%" }} >
                                <div style={{ border: "black solid 2px", width: "30px", height: "30px", margin: "0 auto" }}></div>
                            </td>
                        </tr>

                    </table>
                </div>
            </div>
        </>
    );
};
export default OrderComponentPrint;
